export default __webpack_public_path__ + "static/media/loadingGif.6e505448.gif";